import axios from "axios";
import $ from "jquery";
import React, { Component } from "react";
import { Alert } from "reactstrap";

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailError: "",
      email: "",
      emailSent: false,
    };
    //this.url = "http://localhost:33333";
    this.url = `${process.env.REACT_APP_API_IP}`;
  }

  onChangeEmail = (e) => {
    this.setState({
      email: e.target.value,
      emailError: "",
      emailSent: false,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const postData = {
      email: this.state.email,
      id: 1,
      url: window.location.origin + "/reset-password/",
    };
    const options = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
      },
    };

    let uri = this.url + "/users/forgot-password/";
    console.log(uri, postData);
    axios
      .post(uri, postData, options)

      .then((response) => {
        console.log("response", response.data);

        this.setState({
          emailSent: true,
        });
      })
      .catch((error) => {
        console.log("response", error.response);

        if (error.response.status == 400) {
          this.setState({
            emailError: "active",
          });
        }
      });
  };

  componentDidMount() {
    $(".App-header").hide();
  }

  render() {
    return (
      <div>
        <section className="main-cover">
          <div className="container-fluid custom-container">
            <div className="card-inner">
              <div className="row">
                <div className="col-xl-8 col-lg-7 order-lg-1 order-2">
                  <div className="text-cover">
                    <div>
                      <a href="#" className="brand-name">
                        <img src="/static/media/logo.3c835923.png" alt="" />
                      </a>
                      <h1>Tools for a Healthier You</h1>
                      <p>The Essential Faith Project assists churches and Christian organizations in making, assessing and strengthening disciples of Jesus. Our primary tool is our Spiritual Health Assessment which profiles a person’s level of spiritual well-being across 7 essential domains.</p>
                    </div>
                    <div className="cover-footer">
                      <a href="/privacy">Privacy Policy</a>
                      <a href="/terms">Terms of Service</a>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-5 order-lg-1 order-1">
                  <div className="form-cover">
                    <div className="text-center">
                      <h3>Forgot Password?</h3>
                      <a href="#" className="brand">
                        <img
                          src="data:image/png;base64,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"
                          alt=""
                          className="img-fluid"
                        />
                      </a>
                    </div>
                    <div className="tabs" style={{ marginTop: "10px" }}>
                      <div className="tabs__panels">
                        <Alert color="info" isOpen={this.state.emailSent}>
                          An email has been sent to the email with instructions to reset your password.
                        </Alert>

                        <form onSubmit={this.handleSubmit}>
                          <div className="form-group">
                            <label>Email</label>
                            <div className="form-field">
                              <input type="email" className="form-control" required onChange={this.onChangeEmail} />
                            </div>
                          </div>

                          <span className={`${this.state.emailError} error`}>Email not exists</span>
                          <button className="btn cta-form w-100">Submit</button>
                          <div className="link-cst" />
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
